<script setup>

import Table from "@/components/common/other/Table";
import Button from "@/components/common/input/Button";
import API from "@/classes/global/API";

import {inject} from 'vue';
import {useRoute} from "vue-router";

const route = useRoute();
const shipments = inject("shipments");

async function prepareModal(row) {

  shipments.value.warehousePicksModal = true;
  shipments.value.warehousePicks.selectedShipmentItem = row;

  const response = await API.getWarehouseItems(route, row.warehouseRef);

  if(response) {

    shipments.value.viewShipment.warehouseItems = response;
  }

}

</script>

<template>

  <div class="warehouse-shipment-details-wrapper">
    <Table
        :key="shipments.viewShipment.warehouseHeaders.length"
        height="196"
        :selectable="false"
        :row-selection="false"
        :allow-grid-menu="false"
        :allowPagination="false"
        :dataSource="shipments.viewShipment.warehouseHeaders"
        :columns="shipments.warehouseShipmentDetail.gridColumns">
      <template v-slot:viewPick="row">
        <Button
            @click="prepareModal(row.rowData)"
            type="toolbar"
            text="View">
        </Button>
      </template>
      <template v-slot:moreDetail="row">
        <Button
            @click="prepareModal(row.rowData)"
            type="toolbar"
            text="Details">
        </Button>
      </template>
    </Table>
  </div>

</template>

<style scoped>

.warehouse-shipment-details-wrapper {
  height: 200px;
}
</style>
